// extracted by mini-css-extract-plugin
module.exports = {"readonly":"_2o2_x","noBorder":"bU7du","no-border":"bU7du","no-right-border-radius":"atLsT","noRightBorderRadius":"atLsT"};